import { render, staticRenderFns } from "./HtLabel.vue?vue&type=template&id=cdfe401a&scoped=true&"
import script from "./HtLabel.vue?vue&type=script&lang=js&"
export * from "./HtLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfe401a",
  null
  
)

export default component.exports